/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';
import ImageGalleryContent, { type ImageGalleryContentProps } from './gallery-content';

export { MOSAIC_MAX_IMAGES } from './constants';
export type { GalleryImage } from './gallery-content';

export type ImageGalleryProps = Omit<
    ImageGalleryContentProps,
    'onSelectedImageIndexChange' | 'renderImageOverlay' | 'selectedImageIndex'
>;

/**
 * Reusable image gallery for product cards and modal content. PDP zoom controls are kept in
 * ProductZoomGallery so other gallery consumers do not gain a zoom-specific public API.
 */
export default function ImageGallery(props: ImageGalleryProps): ReactElement {
    return <ImageGalleryContent {...props} />;
}
